import { DetailView } from '@components/enitity'
import { OfferForm } from '@features/offers/components/OfferForm'
import { useCreateOffer } from '@services/offers/mutations/useCreateOffer'
import { useOffersDetail } from '@services/offers/queries/useOffersDetail'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { OfferCreate as OfferCreateType } from 'types/api'

export function OfferCreate() {
  const { id } = useParams()
  const [params] = useSearchParams()
  const { t } = useTranslation('offers')
  const { data: offer } = useOffersDetail(id)
  const navigate = useNavigate()
  const { mutate } = useCreateOffer()

  const onFinish = (values: OfferCreateType) => {
    mutate({
      params: { onSuccess: () => navigate('/admin/offers') },
      body: values
    })
  }

  const applications = params.get('applications')?.split(',') || []

  return (
    <div>
      <DetailView.Breadcrumb
        parentLabel={t('title')}
        parentTo="/admin/offers"
        current={t('admin.form.createTitle')}
      />

      <OfferForm onFinish={onFinish} initialValues={offer} applications={applications} />
    </div>
  )
}
